import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import axios, { axiosSpring } from "../Hooks/axios";
import { showSuccess, showWarning } from '../services/reactToastify';

function Register() {
  const Navigate = useNavigate()
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  console.log(name,email,password)
  const EMAIL =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const [validemail, setValidemail] = useState(true);
  const [validpassword, setValidpassword] = useState(true);
  const [errMsg, setErrMsg] = useState("");
  
  useEffect(() => {
      setValidemail(EMAIL.test(email));
      
    }, [email]);
    // useEffect(() => {
    //   setValidpassword(PASSWORD.test(password));
    // }, [password]);
  
    // useEffect(() => {
    //   setErrMsg("");
    // }, [email, password])
  const checkSubmit = name && email && password
  const handleSubmit = async(e) => {
      if(!checkSubmit){
        showWarning("Fields should not be empty !")
      }

      e.preventDefault();
      const v1 = EMAIL.test(email);
      // const v2 = PASSWORD.test(password);
      if (!v1) {
        setErrMsg("Invalid email or password");
        return;
      }
      
      try {
        const res = await axios.post(
          'api/auth/register',
          JSON.stringify({
          name: name,
          email: email,
          password: password,
          }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
      // console.log(res?.data);
      // console.log(JSON.stringify(res));
        Navigate("/login");
        
      setName("");
      setPassword("");
      setEmail("");
      showSuccess('Registered Successfully')
      // console.log("submitted ");
    }
   catch (err) {
    if (!err?.response) {
      setErrMsg("No Server Response");
    } else if (err.response?.status === 409) {
      setErrMsg("Username Taken");
    } else {
      setErrMsg("Registration Failed");
    } 
  }
  }

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-6 py-14">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-violet-600 rounded-2xl flex items-center justify-center text-white text-3xl font-bold">A</div>
            <span className="text-3xl font-semibold tracking-tight text-white"><Link to='/'>AetherForge</Link></span>
          </div>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-10 shadow-2xl">
          <h2 className="text-3xl font-semibold text-center  text-violet-600 mb-2">Create your account</h2>
          <p className="text-zinc-400 text-center mb-8">Join thousands of product teams building with AetherForge</p>

          <form className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-zinc-400 mb-2">Full Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full text-white bg-zinc-950 border border-zinc-700 focus:border-violet-500 rounded-2xl px-5 py-4 outline-none transition-colors"
                placeholder="Your Name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-zinc-400 mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full text-white bg-zinc-950 border border-zinc-700 focus:border-violet-500 rounded-2xl px-5 py-4 outline-none transition-colors"
                placeholder="you@company.com"
              />
              <label className="block text-sm font-medium text-red-500 mb-2">{email && !validemail ? "* Invalid Email": ""}</label>
            </div>

            <div>
              <label className="block text-sm font-medium text-zinc-400 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full text-white bg-zinc-950 border border-zinc-700 focus:border-violet-500 rounded-2xl px-5 py-4 outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-violet-600 cursor-pointer hover:bg-violet-500 py-4 rounded-2xl font-semibold text-lg transition-all"
              // disabled={!checkSubmit} 
              onClick={handleSubmit}
            >
              Create Account
            </button>
            <label className="block text-sm font-medium text-red-500 mb-2">{email && password && errMsg ? "* Invalid Email or Password": ""}</label>
          </form>

          <p className="text-center text-zinc-400 mt-8">
            Already have an account?{' '}
            <a href="/login" className="text-violet-400 hover:text-violet-300 font-medium">Sign in</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register;